import { MenuItem } from '../models/sidebar';
// import logo from '../assets/images/bebrave-logo.png';

const createMenuItem = (
  id: string,
  name: string,
  path: string,
  icon?: MenuItem['icon'],
  options: Partial<Omit<MenuItem, 'id' | 'name' | 'path' | 'icon'>> = {}
): MenuItem => ({
  id,
  name,
  path,
  icon,
  ...options,
});

/* const createMenuItemWithChildren = (
  id: string,
  name: string,
  path: string,
  icon: MenuItem['icon'],
  children: MenuItem[],
  options: Partial<Omit<MenuItem, 'id' | 'name' | 'path' | 'icon' | 'children'>> = {}
): MenuItem => ({
  id,
  name,
  path,
  icon,
  children,
  ...options,
}); */

export const eagleGptId = 'eaglegpt';

export const menuItems: MenuItem[] = [
  {
    id: 'dashboard',
    name: 'DASHBOARD',
    path: '/dashboard',
    icon: 'LayoutDashboard',
  },
  {
    id: eagleGptId,
    name: 'EAGLEGPT_TITLE',
    path: '/chat',
    icon: 'MessageSquare',
    rightIcon: {iconName: 'SquarePen'},
    // imageIcon: logo,
    isIntegrated: true,
  },
  createMenuItem('document-management', 'DOCUMENT_MANAGEMENT_TITLE', '/document-management', 'FileText', { isIntegrated: true }),
  createMenuItem('my-files', 'MEDIA_LIBRARY', '/media-library', 'FolderClock', { isIntegrated: true }),
  {
    id: 'apps',
    name: 'APPS',
    path: '/home',
    icon: 'LayoutDashboard',
    isIntegrated: true,
  },
  /* createMenuItemWithChildren(
    'file-manager',
    'FILE_MANAGER',
    '/file-manager',
    'Calendar',
    [
      createMenuItem('my-files', 'MEDIA_LIBRARY', '/file-manager/my-files'),
      createMenuItem('shared-files', 'SHARED_WITH_ME', '/file-manager/shared-files'),
      createMenuItem('trash', 'TRASH', '/file-manager/trash',),
    ],
    { isIntegrated: true }
  ), */
];
